module.exports = __webpack_public_path__ + "img/extended.916e08e5.png";